import type { Action } from 'redux';
import type { Redirect } from '../../../../main/screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.types';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIosRedirect = new ReduxAsyncAction<'UPDATE_IOS_REDIRECT', Redirect, { iosRedirect: Redirect }>(
  'UPDATE_IOS_REDIRECT'
);

UpdateIosRedirect.registerRequest(async (iosRedirect: Redirect) => {
  return { iosRedirect };
});

export const UPDATE_IOS_REDIRECT = UpdateIosRedirect.actionNamespaceConstants;
export const updateIosRedirect = UpdateIosRedirect.request;

export type UpdateIosRedirectResponseAction = Action<typeof UPDATE_IOS_REDIRECT.response> & {
  data: { iosRedirect: Redirect };
};
